export const KEY_GET_EMPLOYEES_ME = 'get.employees-me.call';
